/**
 * Generated by orval 🍺
 * Do not edit manually.
 * parktool API
 * Share a few Q-Park parking spots: users register plates and book days, the backend puts the right plate on each spot.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GateLogEntry,
  ListGateLogParams,
  ListSwitchesParams,
  LoginRequest,
  Plate,
  QParkStatus,
  Right,
  SpotDto,
  SpotInput,
  SpotResult,
  SwitchLogEntry,
  SyncReport,
  SyncRow
} from '../models';

import { customFetch } from '../../fetcher.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getListGateLogUrl = (params?: ListGateLogParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/gate-log?${stringifiedParams}` : `/api/admin/gate-log`
}

export const listGateLog = async (params?: ListGateLogParams, options?: Parameters<typeof customFetch>[1]): Promise<GateLogEntry[]> => {

  return customFetch<GateLogEntry[]>(getListGateLogUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListGateLogQueryKey = (params?: ListGateLogParams,) => {
    return [
    `/api/admin/gate-log`, ...(params ? [params] : [])
    ] as const;
    }


export const getListGateLogQueryOptions = <TData = Awaited<ReturnType<typeof listGateLog>>, TError = unknown>(params?: ListGateLogParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGateLog>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListGateLogQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listGateLog>>> = ({ signal }) => listGateLog(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listGateLog>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListGateLogQueryResult = NonNullable<Awaited<ReturnType<typeof listGateLog>>>
export type ListGateLogQueryError = unknown


export function useListGateLog<TData = Awaited<ReturnType<typeof listGateLog>>, TError = unknown>(
 params: undefined |  ListGateLogParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGateLog>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listGateLog>>,
          TError,
          Awaited<ReturnType<typeof listGateLog>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListGateLog<TData = Awaited<ReturnType<typeof listGateLog>>, TError = unknown>(
 params?: ListGateLogParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGateLog>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listGateLog>>,
          TError,
          Awaited<ReturnType<typeof listGateLog>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListGateLog<TData = Awaited<ReturnType<typeof listGateLog>>, TError = unknown>(
 params?: ListGateLogParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGateLog>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListGateLog<TData = Awaited<ReturnType<typeof listGateLog>>, TError = unknown>(
 params?: ListGateLogParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGateLog>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListGateLogQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getPlateSyncStatusUrl = () => {




  return `/api/admin/plates/sync`
}

/**
 * @summary parktool's registered plates next to the Q-Park vehicle list, with the sync status of each.
 */
export const plateSyncStatus = async ( options?: Parameters<typeof customFetch>[1]): Promise<SyncRow[]> => {

  return customFetch<SyncRow[]>(getPlateSyncStatusUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlateSyncStatusQueryKey = () => {
    return [
    `/api/admin/plates/sync`
    ] as const;
    }


export const getPlateSyncStatusQueryOptions = <TData = Awaited<ReturnType<typeof plateSyncStatus>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof plateSyncStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlateSyncStatusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof plateSyncStatus>>> = ({ signal }) => plateSyncStatus({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof plateSyncStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PlateSyncStatusQueryResult = NonNullable<Awaited<ReturnType<typeof plateSyncStatus>>>
export type PlateSyncStatusQueryError = unknown


export function usePlateSyncStatus<TData = Awaited<ReturnType<typeof plateSyncStatus>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof plateSyncStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof plateSyncStatus>>,
          TError,
          Awaited<ReturnType<typeof plateSyncStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlateSyncStatus<TData = Awaited<ReturnType<typeof plateSyncStatus>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof plateSyncStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof plateSyncStatus>>,
          TError,
          Awaited<ReturnType<typeof plateSyncStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlateSyncStatus<TData = Awaited<ReturnType<typeof plateSyncStatus>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof plateSyncStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary parktool's registered plates next to the Q-Park vehicle list, with the sync status of each.
 */

export function usePlateSyncStatus<TData = Awaited<ReturnType<typeof plateSyncStatus>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof plateSyncStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPlateSyncStatusQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getPlateSyncRunUrl = () => {




  return `/api/admin/plates/sync`
}

/**
 * @summary Add plates missing in Q-Park and remove parktool's leftover entries there.
 */
export const plateSyncRun = async ( options?: Parameters<typeof customFetch>[1]): Promise<SyncReport> => {

  return customFetch<SyncReport>(getPlateSyncRunUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getPlateSyncRunMutationKey = () => ['plateSyncRun'] as const;

export const getPlateSyncRunMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof plateSyncRun>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof plateSyncRun>>, TError,void, TContext> => {

const mutationKey = getPlateSyncRunMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof plateSyncRun>>, void> = () => {


          return  plateSyncRun(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlateSyncRunMutationResult = NonNullable<Awaited<ReturnType<typeof plateSyncRun>>>

    export type PlateSyncRunMutationError = unknown


    /**
 * @summary Add plates missing in Q-Park and remove parktool's leftover entries there.
 */
export const usePlateSyncRun = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof plateSyncRun>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof plateSyncRun>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getPlateSyncRunMutationOptions(options), queryClient);
    }
    export const getAdminDeletePlateUrl = (country: string,
    plate: string,) => {




  return `/api/admin/plates/${country}/${plate}`
}

/**
 * @summary Delete a plate wherever it lives: its parktool registration and/or its Q-Park vehicle-list entry.
Refused for the fallback plate and the plate on the parking right; upcoming bookings of the plate are cancelled.
 */
export const adminDeletePlate = async (country: string,
    plate: string, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getAdminDeletePlateUrl(country,plate),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getAdminDeletePlateMutationKey = () => ['adminDeletePlate'] as const;

export const getAdminDeletePlateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminDeletePlate>>, TError,AdminDeletePlateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminDeletePlate>>, TError,AdminDeletePlateMutationVariables, TContext> => {

const mutationKey = getAdminDeletePlateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminDeletePlate>>, AdminDeletePlateMutationVariables> = (props) => {
          const {country,plate} = props ?? {};

          return  adminDeletePlate(country,plate,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminDeletePlateMutationResult = NonNullable<Awaited<ReturnType<typeof adminDeletePlate>>>

    export type AdminDeletePlateMutationError = unknown
    export type AdminDeletePlateMutationVariables = {country: string;plate: string}

    /**
 * @summary Delete a plate wherever it lives: its parktool registration and/or its Q-Park vehicle-list entry.
Refused for the fallback plate and the plate on the parking right; upcoming bookings of the plate are cancelled.
 */
export const useAdminDeletePlate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminDeletePlate>>, TError,AdminDeletePlateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminDeletePlate>>,
        TError,
        AdminDeletePlateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminDeletePlateMutationOptions(options), queryClient);
    }
    export const getListQparkPlatesUrl = () => {




  return `/api/admin/qpark-plates`
}

export const listQparkPlates = async ( options?: Parameters<typeof customFetch>[1]): Promise<Plate[]> => {

  return customFetch<Plate[]>(getListQparkPlatesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListQparkPlatesQueryKey = () => {
    return [
    `/api/admin/qpark-plates`
    ] as const;
    }


export const getListQparkPlatesQueryOptions = <TData = Awaited<ReturnType<typeof listQparkPlates>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listQparkPlates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListQparkPlatesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listQparkPlates>>> = ({ signal }) => listQparkPlates({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listQparkPlates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListQparkPlatesQueryResult = NonNullable<Awaited<ReturnType<typeof listQparkPlates>>>
export type ListQparkPlatesQueryError = unknown


export function useListQparkPlates<TData = Awaited<ReturnType<typeof listQparkPlates>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listQparkPlates>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listQparkPlates>>,
          TError,
          Awaited<ReturnType<typeof listQparkPlates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListQparkPlates<TData = Awaited<ReturnType<typeof listQparkPlates>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listQparkPlates>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listQparkPlates>>,
          TError,
          Awaited<ReturnType<typeof listQparkPlates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListQparkPlates<TData = Awaited<ReturnType<typeof listQparkPlates>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listQparkPlates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListQparkPlates<TData = Awaited<ReturnType<typeof listQparkPlates>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listQparkPlates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListQparkPlatesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getReconcileNowUrl = () => {




  return `/api/admin/reconcile`
}

/**
 * @summary Re-evaluate the bookings now and fix the plate on every spot that is wrong, ignoring the usual timers.
 */
export const reconcileNow = async ( options?: Parameters<typeof customFetch>[1]): Promise<SpotResult[]> => {

  return customFetch<SpotResult[]>(getReconcileNowUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getReconcileNowMutationKey = () => ['reconcileNow'] as const;

export const getReconcileNowMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reconcileNow>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reconcileNow>>, TError,void, TContext> => {

const mutationKey = getReconcileNowMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reconcileNow>>, void> = () => {


          return  reconcileNow(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReconcileNowMutationResult = NonNullable<Awaited<ReturnType<typeof reconcileNow>>>

    export type ReconcileNowMutationError = unknown


    /**
 * @summary Re-evaluate the bookings now and fix the plate on every spot that is wrong, ignoring the usual timers.
 */
export const useReconcileNow = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reconcileNow>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reconcileNow>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getReconcileNowMutationOptions(options), queryClient);
    }
    export const getListRightsUrl = () => {




  return `/api/admin/rights`
}

export const listRights = async ( options?: Parameters<typeof customFetch>[1]): Promise<Right[]> => {

  return customFetch<Right[]>(getListRightsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListRightsQueryKey = () => {
    return [
    `/api/admin/rights`
    ] as const;
    }


export const getListRightsQueryOptions = <TData = Awaited<ReturnType<typeof listRights>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRights>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListRightsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listRights>>> = ({ signal }) => listRights({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listRights>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListRightsQueryResult = NonNullable<Awaited<ReturnType<typeof listRights>>>
export type ListRightsQueryError = unknown


export function useListRights<TData = Awaited<ReturnType<typeof listRights>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRights>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRights>>,
          TError,
          Awaited<ReturnType<typeof listRights>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRights<TData = Awaited<ReturnType<typeof listRights>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRights>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRights>>,
          TError,
          Awaited<ReturnType<typeof listRights>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRights<TData = Awaited<ReturnType<typeof listRights>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRights>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListRights<TData = Awaited<ReturnType<typeof listRights>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRights>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListRightsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetSpotsUrl = () => {




  return `/api/admin/spots`
}

export const getSpots = async ( options?: Parameters<typeof customFetch>[1]): Promise<SpotDto[]> => {

  return customFetch<SpotDto[]>(getGetSpotsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSpotsQueryKey = () => {
    return [
    `/api/admin/spots`
    ] as const;
    }


export const getGetSpotsQueryOptions = <TData = Awaited<ReturnType<typeof getSpots>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSpots>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSpotsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSpots>>> = ({ signal }) => getSpots({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSpots>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSpotsQueryResult = NonNullable<Awaited<ReturnType<typeof getSpots>>>
export type GetSpotsQueryError = unknown


export function useGetSpots<TData = Awaited<ReturnType<typeof getSpots>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSpots>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSpots>>,
          TError,
          Awaited<ReturnType<typeof getSpots>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSpots<TData = Awaited<ReturnType<typeof getSpots>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSpots>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSpots>>,
          TError,
          Awaited<ReturnType<typeof getSpots>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSpots<TData = Awaited<ReturnType<typeof getSpots>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSpots>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSpots<TData = Awaited<ReturnType<typeof getSpots>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSpots>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSpotsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getPutSpotsUrl = () => {




  return `/api/admin/spots`
}

/**
 * @summary Replace the list of spots. The order of the list is the order of the slices in a day cell.
A spot that is left out is removed, which is refused while it has upcoming bookings.
 */
export const putSpots = async (spotInput: SpotInput[], options?: Parameters<typeof customFetch>[1]): Promise<SpotDto[]> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<SpotDto[]>(getPutSpotsUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(spotInput)
  }
);}





export const getPutSpotsMutationKey = () => ['putSpots'] as const;

export const getPutSpotsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putSpots>>, TError,PutSpotsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof putSpots>>, TError,PutSpotsMutationVariables, TContext> => {

const mutationKey = getPutSpotsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putSpots>>, PutSpotsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  putSpots(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutSpotsMutationResult = NonNullable<Awaited<ReturnType<typeof putSpots>>>
    export type PutSpotsMutationBody = SpotInput[]
    export type PutSpotsMutationError = unknown
    export type PutSpotsMutationVariables = {data: SpotInput[]}

    /**
 * @summary Replace the list of spots. The order of the list is the order of the slices in a day cell.
A spot that is left out is removed, which is refused while it has upcoming bookings.
 */
export const usePutSpots = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putSpots>>, TError,PutSpotsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putSpots>>,
        TError,
        PutSpotsMutationVariables,
        TContext
      > => {
      return useMutation(getPutSpotsMutationOptions(options), queryClient);
    }
    export const getListSwitchesUrl = (params?: ListSwitchesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/switches?${stringifiedParams}` : `/api/admin/switches`
}

export const listSwitches = async (params?: ListSwitchesParams, options?: Parameters<typeof customFetch>[1]): Promise<SwitchLogEntry[]> => {

  return customFetch<SwitchLogEntry[]>(getListSwitchesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSwitchesQueryKey = (params?: ListSwitchesParams,) => {
    return [
    `/api/admin/switches`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSwitchesQueryOptions = <TData = Awaited<ReturnType<typeof listSwitches>>, TError = unknown>(params?: ListSwitchesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSwitches>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSwitchesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSwitches>>> = ({ signal }) => listSwitches(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSwitches>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSwitchesQueryResult = NonNullable<Awaited<ReturnType<typeof listSwitches>>>
export type ListSwitchesQueryError = unknown


export function useListSwitches<TData = Awaited<ReturnType<typeof listSwitches>>, TError = unknown>(
 params: undefined |  ListSwitchesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSwitches>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSwitches>>,
          TError,
          Awaited<ReturnType<typeof listSwitches>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSwitches<TData = Awaited<ReturnType<typeof listSwitches>>, TError = unknown>(
 params?: ListSwitchesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSwitches>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSwitches>>,
          TError,
          Awaited<ReturnType<typeof listSwitches>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSwitches<TData = Awaited<ReturnType<typeof listSwitches>>, TError = unknown>(
 params?: ListSwitchesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSwitches>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListSwitches<TData = Awaited<ReturnType<typeof listSwitches>>, TError = unknown>(
 params?: ListSwitchesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSwitches>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSwitchesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getQparkDisconnectUrl = () => {




  return `/api/qpark/connection`
}

export const qparkDisconnect = async ( options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getQparkDisconnectUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getQparkDisconnectMutationKey = () => ['qparkDisconnect'] as const;

export const getQparkDisconnectMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof qparkDisconnect>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof qparkDisconnect>>, TError,void, TContext> => {

const mutationKey = getQparkDisconnectMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof qparkDisconnect>>, void> = () => {


          return  qparkDisconnect(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type QparkDisconnectMutationResult = NonNullable<Awaited<ReturnType<typeof qparkDisconnect>>>

    export type QparkDisconnectMutationError = unknown


    export const useQparkDisconnect = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof qparkDisconnect>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof qparkDisconnect>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getQparkDisconnectMutationOptions(options), queryClient);
    }
    export const getQparkLoginUrl = () => {




  return `/api/qpark/login`
}

/**
 * @summary Log in to Q-Park. The password is used for this request only and is not stored.
 */
export const qparkLogin = async (loginRequest: LoginRequest, options?: Parameters<typeof customFetch>[1]): Promise<QParkStatus> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<QParkStatus>(getQparkLoginUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(loginRequest)
  }
);}





export const getQparkLoginMutationKey = () => ['qparkLogin'] as const;

export const getQparkLoginMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof qparkLogin>>, TError,QparkLoginMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof qparkLogin>>, TError,QparkLoginMutationVariables, TContext> => {

const mutationKey = getQparkLoginMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof qparkLogin>>, QparkLoginMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  qparkLogin(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type QparkLoginMutationResult = NonNullable<Awaited<ReturnType<typeof qparkLogin>>>
    export type QparkLoginMutationBody = LoginRequest
    export type QparkLoginMutationError = unknown
    export type QparkLoginMutationVariables = {data: LoginRequest}

    /**
 * @summary Log in to Q-Park. The password is used for this request only and is not stored.
 */
export const useQparkLogin = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof qparkLogin>>, TError,QparkLoginMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof qparkLogin>>,
        TError,
        QparkLoginMutationVariables,
        TContext
      > => {
      return useMutation(getQparkLoginMutationOptions(options), queryClient);
    }
    export const getQparkStatusUrl = () => {




  return `/api/qpark/status`
}

export const qparkStatus = async ( options?: Parameters<typeof customFetch>[1]): Promise<QParkStatus> => {

  return customFetch<QParkStatus>(getQparkStatusUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getQparkStatusQueryKey = () => {
    return [
    `/api/qpark/status`
    ] as const;
    }


export const getQparkStatusQueryOptions = <TData = Awaited<ReturnType<typeof qparkStatus>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof qparkStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getQparkStatusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof qparkStatus>>> = ({ signal }) => qparkStatus({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof qparkStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type QparkStatusQueryResult = NonNullable<Awaited<ReturnType<typeof qparkStatus>>>
export type QparkStatusQueryError = unknown


export function useQparkStatus<TData = Awaited<ReturnType<typeof qparkStatus>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof qparkStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof qparkStatus>>,
          TError,
          Awaited<ReturnType<typeof qparkStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useQparkStatus<TData = Awaited<ReturnType<typeof qparkStatus>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof qparkStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof qparkStatus>>,
          TError,
          Awaited<ReturnType<typeof qparkStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useQparkStatus<TData = Awaited<ReturnType<typeof qparkStatus>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof qparkStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useQparkStatus<TData = Awaited<ReturnType<typeof qparkStatus>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof qparkStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getQparkStatusQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






